module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/features/buttons/size-buttons/size-buttons.component.scss
// module id = ./src/app/features/buttons/size-buttons/size-buttons.component.scss
// module chunks = main